<template>
  <a @click="onClick" style="font-size: 13px;">
    <slot v-if="!loading"></slot>
    <i v-else class="fa fa-spinner fa-spin"></i>
  </a>
</template>



<script>
export default {
  props: ["loading"],
  data() {
    return {};
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  },
  created() {}
};
</script>
